
(function ($, root, undefined) {

	$(function () {
		'use strict';

    // ScrollTrigger
    gsap.registerPlugin(ScrollTrigger);

    // Animation au scroll du block image + image
    gsap.to('.image-image-left', {
      scrollTrigger: {
        trigger: '.image-image-content',
        start: 'top bottom',
        end: 'bottom 0px',
        scrub: 1,
        //markers: true
      },
      y: -150,
    });
    gsap.to('.image-image-right', {
      scrollTrigger: {
        trigger: '.image-image-content',
        start: 'top bottom',
        end: 'bottom 0px',
        scrub: 1,
        //markers: true
      },
      y: 150,
    });

    // Slider
    const swiperSlider = new Swiper(".swiper-full-image", {
      slidesPerView: 1,
      loop: true,
      dynamicBullets: true,
      effect: "fade",
      slidesOffsetAfter: 0,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '"></span>';
          },
      },
    });

    // Slider Tabs
    var titles = [];
    $('.swiper-slidertabs .swiper-wrapper .swiper-slide').each(function(i, element) {
      titles.push($(element).find('.slide-title')[0].innerText);
    });

    const swiperSliderTabs = new Swiper(".swiper-slidertabs", {
      loop: true,
      dynamicBullets: true,
      effect: "fade",
      fadeEffect: { crossFade: true },
      allowTouchMove: true,
      pagination: {
        el: '.swiper-tabs-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return '<div class="' + className + ' slidertab-name">' + titles[index] + '<span class="material-symbols-outlined">arrow_forward</span></div>';
        }
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
        disabledClass: '.swiper-button-disabled'
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false
      },
      breakpoints: {
        600: {
          allowTouchMove: false,
        }
      }
    });

    // Slider (Image + Titre + Description)
    const swiperSliderITD = new Swiper(".swiper-slideritd", {
      loop: true,
      dynamicBullets: true,
      slidesPerView: 2,
      spaceBetween: 10,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '"></span>';
          },
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      enabled: true,
      // Responsive breakpoints
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 20,
          enabled: true
        },
        780: {
          slidesPerView: 2,
          spaceBetween: 30,
          enabled: true
        }
      }
    });

    // Slider Réalisations (Image + Titre + Description)
    const swiperSliderREA = new Swiper(".swiper-slider-realisations", {
      loop: true,
      dynamicBullets: true,
      slidesPerView: 2,
      spaceBetween: 10,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '"></span>';
          },
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      enabled: true,
      // Responsive breakpoints
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 20,
          enabled: true
        },
        780: {
          slidesPerView: 2,
          spaceBetween: 30,
          enabled: true
        }
      }
    });

    // Scroll to top
    var btn = $('#button');
    $(window).scroll(function() {
      if ($(window).scrollTop() > 300) {
        btn.addClass('show');
      } else {
        btn.removeClass('show');
      }
    });

    btn.on('click', function(e) {
      e.preventDefault();
      $('html, body').animate({scrollTop:0}, '300');
    });

    // Scroll to anchor
    var $root = $('html, body');
    $('a[href^="#"]').click(function() {
      if($(this).hasClass('.anchor-link')) {
        var href = $.attr(this, 'href');
        $root.animate({scrollTop: $(href).offset().top}, 500, function() {
          window.location.hash = href;
        });
        return false;
      }
    });

    // Fonction fixe navigation
    fixeNav();

    function fixeNav() {
      var lastScrollTop = 0;
      var threshold = 200;

      $(window).scroll(function(event){
        var currentScrollTop = $(this).scrollTop();

        if (lastScrollTop < threshold){
          $('.bkgHeader').removeClass("stickcolored");
        } else {
          $('.bkgHeader').addClass("stickcolored");
        }

        if (currentScrollTop > lastScrollTop && lastScrollTop > threshold){
          $('.header').addClass("stickhidden");
        } else {
          $('.header').removeClass("stickhidden");
        }

        lastScrollTop = currentScrollTop;
      });
    }

    initSite();

    function initSite() {
      // Toogle Navigation Mobile
      $('.menu-item-has-children').click(function(){
        //Expand or collapse this panel
        $(".menu-item-has-children").not($(this)).removeClass('active');
        $(this).toggleClass('active');
      });
    }
	});

})(jQuery, this);


